import { withLoading } from "hocs/withLoading";
import { lazy } from "react";

export const TopCompanies = withLoading(lazy(() => import("./TopCompanies")));
export const Categories = withLoading(lazy(() => import("./Categories")));
export * from "../../../Components/Banners";
export const TopProducts = withLoading(lazy(() => import("./TopProducts")));
export const QuickSourcing = withLoading(lazy(() => import("./QuickSourcing")));
export const FeatureBuyers = withLoading(lazy(() => import("./FeatureBuyers")));
export * from "./Benefits";
export * from "./Statistics";
export * from "./Trending";
export { default as Testimonials } from "./Testimonials";
export { default as FeatureRFQs } from "./FeatureRFQs";
export { default as NewArrivals } from "./NewArrivals";
export { default as PopularProducts } from "./PopularProducts";
export { default as HomeSearch } from "./HomeSearch";
